exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-list-wrapper{display:flex;width:100%;min-height:50px;flex-wrap:nowrap;align-items:center;justify-content:flex-start;overflow-x:auto;scrollbar-width:none;-ms-overflow-style:none}.modal-list-wrapper::-webkit-scrollbar{display:none}.modal-list-wrapper .modal-list-container{display:flex;width:100%;min-height:50px;margin-bottom:14px;padding:0 2px;align-items:center;justify-content:flex-start;gap:10px;flex-wrap:nowrap}.modal-list-wrapper .modal-list-container button{height:32px;padding:0 8px;flex-shrink:0;border:none;border-radius:18px;box-shadow:0 2px 3px rgba(0,0,0,.29)}.modal-list-wrapper .modal-list-container button span.title{display:inline-block;margin:0 8px;font-size:12px;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/CustomizeTerm/Common/ProductModalList.scss
// module id = 8132
// module chunks = 13